/**
 * Verrou d'inactivite : au bout d'un temps sans geste, on redemande le mot de passe.
 *
 * POURQUOI CE MODULE EXISTE. La fenetre de re-saisie ne s'ouvrait que sur un 401
 * venu du serveur, et seulement si le renouvellement silencieux echouait. Avec
 * « Se souvenir de moi », ce renouvellement reussit : un poste laisse ouvert
 * restait ouvert. L'application promettait pourtant « Deconnexion automatique
 * dans » - une promesse que rien ne tenait.
 *
 * POURQUOI ON LIT L'HORLOGE ET NON LES TOURS. Compter en additionnant les tours
 * d'un `setInterval` suppose que les tours arrivent. Un portable referme n'en
 * recoit plus, et se reveille avec un compteur en retard de plusieurs heures :
 * le verrou se refermerait longtemps apres le retour de l'agent, c'est-a-dire au
 * pire moment. On compare donc deux instants.
 *
 * POURQUOI LA LOGIQUE EST SEPAREE DU DOM. Brancher des ecouteurs demande un
 * navigateur ; compter le temps non. Ce qui est ici se verifie sans rendu - le
 * depot n'a pas de bibliotheque de rendu, et ce qui n'est pas extrait n'est pas
 * teste.
 */
export function creerMinuteurInactivite({ delaiMs, maintenant = Date.now, surInactivite }) {
  let dernierGeste = maintenant();
  let dejaDeclenche = false;

  // Un delai nul ou negatif DESARME. Un `REACT_APP_INACTIVITE_MS` mal renseigne
  // rendrait sinon l'ecart toujours superieur au delai : l'application se
  // verrouillerait a chaque tour de verification, et l'agent ne pourrait plus
  // rien faire.
  const arme = Number.isFinite(delaiMs) && delaiMs > 0;

  return {
    /** Un geste de l'utilisateur : l'echeance repart, et le verrou se rearme. */
    signalerActivite() {
      dernierGeste = maintenant();
      dejaDeclenche = false;
    },

    /**
     * Appelee periodiquement. Rend vrai le tour ou le verrou se referme.
     *
     * Ne declenche QU'UNE FOIS par periode d'inactivite : la verification tourne
     * toutes les quinze secondes, et sans ce garde-fou un poste inactif ouvrirait
     * une fenetre de re-saisie toutes les quinze secondes.
     */
    verifier() {
      if (!arme || dejaDeclenche) return false;
      if (maintenant() - dernierGeste < delaiMs) return false;
      dejaDeclenche = true;
      surInactivite();
      return true;
    },

    /** Pour le diagnostic : l'instant du dernier geste observe. */
    dernierGeste() {
      return dernierGeste;
    },
  };
}
